export enum LoadingState {
    BASE = 'base',
    USER = 'user',
    TENANT = 'tenant',
    PREPARING_ACCOUNT = 'preparing_account',
    LOADED = 'loaded',
}
